import script from "./ThermodynamicsExperiment.vue?vue&type=script&setup=true&lang=js"
export * from "./ThermodynamicsExperiment.vue?vue&type=script&setup=true&lang=js"

import "./ThermodynamicsExperiment.vue?vue&type=style&index=0&id=24f98d6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f98d6f"]])

export default __exports__